<template>
  <div
    class="  px-10 mt-7">
    <v-layout wrap>
      <v-flex>
        <section>

          <v-row>
            <v-col cols="3">
              <v-card
                flat
                class="pa-5 border-radius-card">
                <div>
                  <v-list
                    subheader
                    two-line
                    class="pb-0"
                  >
                    <v-list-item class="px-0"
                    >
                      <v-list-item-avatar class="my-1" size="65">
                        <v-img
                          contain
                          alt="Distributor Amanata"  
                          :src="require('@/assets/icon/personal.png')"
                          class="">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="30"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title style="color: #4828a1;" class="fs-16 mb-1">Personal Loans</v-list-item-title>

                        <v-list-item-subtitle class="fs-20 font-weight-medium color-dark-blue">$50,000</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>

            <v-col cols="3">
              <v-card
                flat
                class="pa-5 border-radius-card">
                <div>
                  <v-list
                    subheader
                    two-line
                    class="pb-0"
                  >
                    <v-list-item class="px-0"
                    >
                      <v-list-item-avatar class="my-1" size="65">
                        <v-img
                          contain
                          alt="Distributor Amanata"  
                          :src="require('@/assets/icon/corporate.png')"
                          class="">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="30"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title style="color: #4828a1;" class="fs-16 mb-1">Corporate Loans</v-list-item-title>

                        <v-list-item-subtitle class="fs-20 font-weight-medium color-dark-blue">$100,000</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>


            <v-col cols="3">
              <v-card
                flat
                class="pa-5 border-radius-card">
                <div>
                  <v-list
                    subheader
                    two-line
                    class="pb-0"
                  >
                    <v-list-item class="px-0"
                    >
                      <v-list-item-avatar class="my-1" size="65">
                        <v-img
                          contain
                          alt="Distributor Amanata"  
                          :src="require('@/assets/icon/business.png')"
                          class="">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="30"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title style="color: #4828a1;" class="fs-16 mb-1">Business Loans</v-list-item-title>

                        <v-list-item-subtitle class="fs-20 font-weight-medium color-dark-blue">$500,000</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>


            <v-col cols="3">
              <v-card
                flat
                class="pa-5 border-radius-card">
                <div>
                  <v-list
                    subheader
                    two-line
                    class="pb-0"
                  >
                    <v-list-item class="px-0"
                    >
                      <v-list-item-avatar class="my-1" size="65">
                        <v-img
                          contain
                          alt="Distributor Amanata"  
                          :src="require('@/assets/icon/custom.png')"
                          class="">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="30"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title style="color: #4828a1;" class="fs-16 mb-1">Custom Loans</v-list-item-title>

                        <v-list-item-subtitle class="fs-20 font-weight-medium color-dark-blue">Choose Money</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="fs-22 mb-3 color-dark-blue font-weight-medium">
                Active Loans Overview
              </div>

              <v-card
                flat
                class="pa-5 border-radius-card">
                <table style="width: 100%;">
                  <tr>
                    <th style="padding-bottom: 8px; border-bottom: thin solid #E6EFF5;" class="fs-16 color-light-blue font-weight-medium">SL No</th>
                    <th style="padding-bottom: 8px; border-bottom: thin solid #E6EFF5;" class="fs-16 color-light-blue font-weight-medium">Loan Money</th>
                    <th style="padding-bottom: 8px; border-bottom: thin solid #E6EFF5;" class="fs-16 color-light-blue font-weight-medium">Left to repay</th>
                    <th style="padding-bottom: 8px; border-bottom: thin solid #E6EFF5;" class="fs-16 color-light-blue font-weight-medium">Duration</th>
                    <th style="padding-bottom: 8px; border-bottom: thin solid #E6EFF5;" class="fs-16 color-light-blue font-weight-medium">Interest rate</th>
                    <th style="padding-bottom: 8px; border-bottom: thin solid #E6EFF5;" class="fs-16 color-light-blue font-weight-medium">Installment</th>
                    <th style="padding-bottom: 8px; border-bottom: thin solid #E6EFF5;" class="fs-16 color-light-blue font-weight-medium">Repay</th>
                  </tr>

                  <tr v-for="item in 10" :key="item">
                    <td style="padding: 8px 0px; border-bottom: thin solid #F2F4F7;" class="fs-16 color-dark-blue">{{ item }}</td>
                    <td style="padding: 8px 0px; border-bottom: thin solid #F2F4F7;" class="fs-16 color-dark-blue">${{ item+10 }}00,000</td>
                    <td style="padding: 8px 0px; border-bottom: thin solid #F2F4F7;" class="fs-16 color-dark-blue">${{ item+2 }}0,500</td>
                    <td style="padding: 8px 0px; border-bottom: thin solid #F2F4F7;" class="fs-16 color-dark-blue">{{ item+1 }} Months</td>
                    <td style="padding: 8px 0px; border-bottom: thin solid #F2F4F7;" class="fs-16 color-dark-blue">1{{ item }}%</td>
                    <td style="padding: 8px 0px; border-bottom: thin solid #F2F4F7;" class="fs-16 color-dark-blue">${{ item+4 }},000 / month</td>
                    <td style="padding: 8px 0px; border-bottom: thin solid #F2F4F7; width: 160px;" class="fs-16 color-dark-blue">
                      <v-tooltip 
                        top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            outlined
                            rounded
                            v-bind="attrs"
                            v-on="on"
                            elevation="0"
                            color="#123288"
                            height="35"
                            width="150"
                            class="text-capitalize ma-2"
                          >
                            Repay
                          </v-btn>
                        </template>

                        <span>Repay</span>
                      </v-tooltip>
                    </td>
                  </tr>

                  <tr>
                    <td style="padding: 8px 0px; color: #FE5C73;" class="fs-16 font-weight-medium">Total</td>
                    <td style="padding: 8px 0px; color: #FE5C73;" class="fs-16 font-weight-medium">$125,0000</td>
                    <td style="padding: 8px 0px; color: #FE5C73;" class="fs-16 font-weight-medium">$750,000</td>
                    <td style="padding: 8px 0px; color: #FE5C73;" class="fs-16 font-weight-medium"></td>
                    <td style="padding: 8px 0px; color: #FE5C73;" class="fs-16 font-weight-medium"></td>
                    <td style="padding: 8px 0px; color: #FE5C73;" class="fs-16 font-weight-medium">$50,000 / month</td>
                    <td style="padding: 8px 0px; color: #FE5C73; width: 160px;" class="fs-16 font-weight-medium">
                      
                    </td>
                  </tr>
                </table>
              </v-card>
            </v-col>
          </v-row>


        </section>
      </v-flex>
    </v-layout>
  </div>
</template>


<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        process: {
          load: true
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },

      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },


      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    components: {
      
    },

    watch: {

    },
    mounted () {
      setTimeout(() => {
        this.process.load = false
      }, 1000)
    },
    methods: {
      
    }
  }
</script>

<style>
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;

    /* background-color: #4828a1; */
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  }


  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #4828a1;
  }
</style>